export default class FileModel {
  constructor(option) {
    this.name = option.name || '';
    this.size = option.size || 0;
    this.type = option.type || '';
    this.url = option.url || '';
    this.file = option.file || null;
  }
}
